import { useEffect } from 'react'
import { refreshSettings, getSettings } from 'utils/settingsService'
import { useDispatch, useSelector } from 'react-redux'
import { isAuthenticated } from 'utils/authService'

const withSettings = Component => {
  function ComponentWithSettings(props) {
    const settings = useSelector(getSettings)
    const dispatch = useDispatch()

    useEffect(() => {
      if (settings || !isAuthenticated()) return
      ;(async () => {
        refreshSettings(dispatch)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Component {...props} settings={settings} />
  }

  return ComponentWithSettings
}

export default withSettings
